module.exports = __webpack_public_path__ + "static/media/certificate-alt-1.cd1c9b11.svg";